export default {
    PtWorkspaceFolderTree: {
        noData: '未找到对应文件夹',
        myWorkspace: '我的工作空间',
        sharedWorkspace: '来自分享的工作空间',
        publicWorkspace: '企业工作空间',
        noFolder: '该工作空间无文件夹，请尝试选择其他工作空间。',
    },
};
